import { HttpRequest3fsc4149kgwfg as HttpRequest } from './HttpRequest.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DefaultHttpRequestClass;
function DefaultHttpRequest() {
  if (DefaultHttpRequestClass === VOID) {
    class $ {
      constructor(call, data) {
        this.q5u_1 = call;
        this.r5u_1 = data.k5l_1;
        this.s5u_1 = data.j5l_1;
        this.t5u_1 = data.m5l_1;
        this.u5u_1 = data.l5l_1;
        this.v5u_1 = data.o5l_1;
      }
      x5i() {
        return this.q5u_1;
      }
      bw() {
        return this.x5i().bw();
      }
      y5i() {
        return this.r5u_1;
      }
      z5i() {
        return this.s5u_1;
      }
      z2n() {
        return this.t5u_1;
      }
      x51() {
        return this.u5u_1;
      }
      r5i() {
        return this.v5u_1;
      }
    }
    initMetadataForClass($, 'DefaultHttpRequest', VOID, VOID, [HttpRequest()]);
    DefaultHttpRequestClass = $;
  }
  return DefaultHttpRequestClass;
}
//region block: exports
export {
  DefaultHttpRequest as DefaultHttpRequest19v463zllbymg,
};
//endregion

//# sourceMappingURL=DefaultHttpRequest.mjs.map
